var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rd-dictionary-selector',{attrs:{"multiple":_vm.multiple,"label":_vm.label,"is-object":true,"type":_vm.type,"url":_vm.url},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})}
var staticRenderFns = []

export { render, staticRenderFns }